import React, { useState, useRef } from 'react';
import { useForm } from 'react-hook-form';

// import Select from 'react-select';

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from 'reactstrap';
import { db } from '../db/config';
import * as firebase from 'firebase';

//installed this library
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { PartyMode } from '@mui/icons-material';

const functions = firebase.functions();
function Edit_User({ myUser, onClick, setUserData, userData, notify }) {
  console.log('EDitEDitEDitEDit',myUser)
  const [visible, setVisible] = useState(false);
  const [error, setError] = useState('');
  const { register, handleSubmit, errors } = useForm();
  const [showpassword, setShowPassword] = useState(false);

  const usersv = firebase.auth();

  console.log('auth', usersv);

  const TeacherPermision =[
    { label: 'Book Management', value: 'Book_Management' },
    { label: 'Mock Management', value: 'Quiz_Management' },
    { label: 'Batch Management', value: 'Batch_Management' },
    { label: 'Session Management', value: 'Session_Management' },
  ]
  //added this for the options
  const options = [
    // { label: 'Dashboard', value: 'Dashboard' },
    { label: 'User Management', value: 'User_Management' },
    { label: 'Student Management', value: 'Student_Management' },
    { label: 'Teacher Management', value: 'Teacher_Management' },
    { label: 'Book Management', value: 'Book_Management' },
    { label: 'Mock Management', value: 'Quiz_Management' },
    { label: 'Session Management', value: 'Session_Management' },
    { label: 'Subject Management', value: 'Subject_Management' },
    { label: 'Package Management', value: 'Package_Management' },
    // { label: 'Transaction Management', value: 'Transaction_Management' },
    { label: 'Batch Management', value: 'Batch_Management' },
    { label: 'Enquiry', value: 'Enquiry' },
    { label: 'Feedback', value: 'Feedback' },
    { label: 'Chat', value: 'Chat' },
    { label: 'Media Center', value: 'Media_Center' },
    { label: 'Discount Management', value: 'Discount_Management' },
    { label: 'Invoice Management', value: 'Invoice_Management' },
    { label: 'Notification Management', value: 'Notification_Management' },
    // { label: 'Reports', value: 'Reports' },
  ];
  //added this for the state to pass to firebase
  const [selectedPermission, setselectedPermission] = useState(
    myUser.permissions
  );

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? '#272a3d' : 'black',
      padding: 10,
    }),
    control: () => ({
      display: 'none',
    }),
  };
  return (
    <div className='content'>
      <Row>
        <Col>
          <Card style={{ margin: 0 }}>
            <CardHeader>
              <h5 className='title'>Edit User</h5>
            </CardHeader>
            <CardBody>
              <form
                style={{}}
                onSubmit={handleSubmit((data) => {
                  if(selectedPermission.length === 0) return notify('Please select at least one permission', true);
                  setVisible(true);
                  const updatedData = {
                    firstname: data?.firstname,
                    lastname: data?.lastname,
                    mobile: data?.mobile,
                    email: data?.email,
                    disabled: myUser?.disabled,
                    // status:myUser.status,
                    permissions: selectedPermission,
                    password: data?.password,
                    username: data?.username,
                  };
                  
                  // Only include modificationAccess if it has a valid value
                  if (data?.modificationAccess !== undefined && data?.modificationAccess !== '') {
                    updatedData.modificationAccess = data.modificationAccess;
                  }
                  
                  console.log('updatedDataupdatedDataupdatedData',updatedData);
// return;
                  if (data?.email === myUser?.email) {
                    db.collection('zSystemUsers')
                      .doc(myUser._uniqueID.toString())
                      .update(updatedData)
                      .then(function () {
                        // console.log('documnet successfully inserted')
                        onClick();
                        notify('User updated successfully', false);
                        // setVisible(true)
                        // setUserData(updatedData)
                        setUserData((prev) =>
                          prev.map((item) =>
                            item._uniqueID === myUser._uniqueID
                              ? { ...updatedData, _uniqueID: myUser._uniqueID }
                              : item
                          )
                        );
                        // console.log('sucesssssssssss',updatedData)
                      })
                      .catch(function (error) {
                        notify(error.toString(), true);

                        console.log('this is error', error);
                      });
                  }
                  if (
                    data?.email !== myUser?.email ||
                    data?.password !== myUser?.password
                  ) {
                    // else started
                    let status = myUser?.disabled;

                    const updateUserData = {
                      userID: myUser._uniqueID,
                      disabled: status,
                      httpcalltype: 'update',
                      email: data?.email,
                      newpassword: data?.password,
                    };

                    const updateUser = functions.httpsCallable('updateUser');
                    updateUser(updateUserData)
                      .then((result) => {
                        console.log(result);
                        if (result.data.hasError === false) {
                          console.log('result', result);
                          const _uniqueID = result.data.user.uid;

                          db.collection('zSystemUsers')
                            .doc(_uniqueID)
                            .update(updatedData)
                            .then(() => {
                              /*        setUserData((prev) =>
                                prev.map((item) =>
                                  item._uniqueID == myUser._uniqueID
                                    ? { ...updatedData, _uniqueID: myUser._uniqueID }
                                    : item
                                )
                              ); */
                              notify(`User updated successfully`, false);
                              onClick();
                              console.log(status);
                            })
                            .catch((error) => {
                              notify(error.toString(), true);

                              console.log('this is error ', error);
                            });
                        } else {
                          notify(
                            result.data.message.errorInfo.message.toString(),
                            true
                          );
                        }
                      })
                      .catch((error) => {
                        notify(error.toString(), true);

                        console.log('this is error ', error);
                      });

                    // else ended
                  }
                })}
              >
                <Row className='lg' md='1'>
                  <Col className='lg' md='3'>
                    <FormGroup>
                      <label>First*</label>
                      <input
                        className='form-control'
                        defaultValue={myUser?.firstname}
                        {...register('firstname', { required: true })}
                        name='firstname'
                        placeholder='First Name'
                        type='text'
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col className='lg' md='3'>
                    <FormGroup>
                      <label>Last Name*</label>
                      <input
                        className='form-control'
                        defaultValue={myUser?.lastname}
                        {...register('lastname')}
                        name='lastname'
                        placeholder='Last Name'
                        type='text'
                      />
                    </FormGroup>
                  </Col>
                  <Col className='pl-md-1' md='4'>
                    <FormGroup>
                      <label>Username*</label>
                      <input
                        className='form-control'
                        defaultValue={myUser?.username}
                        placeholder='username'
                        type='text'
                        name='username'
                        {...register('username', {
                          required: true,
                          minLength: 6,
                        })}
                      />
                      {errors?.username &&
                        errors?.username.type === 'minLength' && (
                          <span
                            style={{
                              fontSize: '10px',
                              position: 'absolute',
                              bottom: '-20px',
                              color: 'red',
                            }}
                          >
                            Password should be atleast 6 digits.
                          </span>
                        )}
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col className='pr-md-1' md='6'>
                    <FormGroup>
                      <label>Email*</label>
                      <input
                        className='form-control'
                        defaultValue={myUser?.email}
                        {...register('email', { required: true })}
                        name='email'
                        placeholder='user@user.com'
                        type='email'
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col className='pl-md-1' md='6'>
                    <FormGroup>
                      <label>Password*</label>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'end',
                          alignItems: 'center',
                        }}
                      >
                        <input
                          className='form-control'
                          defaultValue={myUser?.password}
                          {...register('password', {
                            required: true,
                            minLength: 6,
                          })}
                          required
                          name='password'
                          type={showpassword ? 'text' : 'password'}
                          placeholder='Password'
                        />

                        {showpassword ? (
                          <div
                            style={{
                              position: 'absolute',
                              paddingRight: '15px',
                              cursor: 'pointer',
                            }}
                            onClick={() => setShowPassword(!showpassword)}
                          >
                            <i class='fa fa-eye-slash' aria-hidden='true'></i>
                          </div>
                        ) : (
                          <div
                            style={{
                              position: 'absolute',
                              paddingRight: '15px',
                              cursor: 'pointer',
                            }}
                            onClick={() => setShowPassword(!showpassword)}
                          >
                            <i class='fa fa-eye' aria-hidden='true'></i>
                          </div>
                        )}
                      </div>

                      {errors?.password &&
                        errors?.password.type === 'minLength' && (
                          <span
                            style={{
                              fontSize: '10px',
                              position: 'absolute',
                              bottom: '-20px',
                              color: 'red',
                            }}
                          >
                            Password should be atleast 6 digits.
                          </span>
                        )}
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col className='pr-md-1' md='6'>
                    <FormGroup>
                      <label>Mobile*</label>
                      <input
                        className='form-control'
                        defaultValue={myUser?.mobile}
                        {...register('mobile', {
                          minLength: 10,
                          maxLength: 10,
                          required: true,
                        })}
                        name='mobile'
                        placeholder='Mobile'
                        type='mobile'
                        required
                      />

                      {errors?.mobile && errors?.mobile.type !== 'required' && (
                        <span
                          style={{
                            fontSize: '10px',
                            position: 'absolute',
                            bottom: '-20px',
                            color: 'red',
                          }}
                        >
                          Please Enter Valid Mobile No.
                        </span>
                      )}
                    </FormGroup>
                  </Col>
                  <Col className='pl-md-1' md='6'>
                    <FormGroup>
                      <label>Account Permission*</label>
                      {/* Added this library */}
                      <ReactMultiSelectCheckboxes
                        defaultValue={selectedPermission}
                        styles={customStyles}
                        onChange={(option) => {
                          setselectedPermission(option);
                          // console.log(`Option selected:`, option);
                        }}
                        options={options}
                      />
                    </FormGroup>
                  </Col>
                  <Col className='pl-md-1' md='6'>
                    {/* <FormGroup>
                          <label style={{marginLeft:10}}>User Role</label>
                          
                         <Input defaultValue={myUser.role} type='select' name='role' {...register({required:true})}>
                           <option>admin</option>
                           <option>superadmin</option>
                         </Input>
                        </FormGroup> */}
                  </Col>
                </Row>
                {selectedPermission.map((item) => {
                  if (item.value === 'Student_Management') {
                    return (
                      <Row key="modification-access">
                        <Col className='lg' md={6}>
                          <FormGroup>
                            <label>Modification Access</label>
                            <select
                              className='form-control'
                              defaultValue={myUser?.modificationAccess}
                              {...register('modificationAccess', {
                                required: false,
                              })}
                              type='select'
                              name='modificationAccess'
                            >
                              <option value=''>Please select the access</option>
                              <option value={0}>
                                Student modification access
                              </option>
                            </select>
                          </FormGroup>
                        </Col>
                      </Row>
                    );
                  }
                  return null;
                })}
                <div>
                  <Button className='btn-fill' color='info' type='submit'>
                    Save
                  </Button>
                  <Button className='btn-fill' onClick={onClick}>
                    Back
                  </Button>
                  {/* {visible === false ? <Button className="btn-fill" color="info" type="submit">
                    Save
                  </Button> : <Button onClick={onClick} className="btn-fill" color="info">Done</Button>}
                  {visible === false && <Button className="btn-fill" onClick={onClick}>Back</Button>} */}
                </div>
              </form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Edit_User;
